import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../context/SEOContext';
// import { CALC_ROUTES } from '../App';
import { CALC_ROUTES } from '../config/Calc_Routes';
import Footer from './Footer';


const ALL_PATHS = ['/', ...Object.values(CALC_ROUTES).flat().map(i => i.path)];
const ALL_NAMES = { '/': 'Home Page', ...Object.values(CALC_ROUTES).flat().reduce((a, i) => ({ ...a, [i.path]: i.name }), {}) };

const inp = {
  width: '100%', background: 'var(--input)', border: '1.5px solid var(--border)',
  borderRadius: '10px', padding: '11px 14px', color: 'var(--t1)',
  fontFamily: 'Inter, sans-serif', fontSize: '14px', outline: 'none',
  transition: 'border-color 0.2s',
};
const textareaStyle = { ...inp, resize: 'vertical', minHeight: '80px', fontFamily: 'Inter, sans-serif', lineHeight: 1.6 };
const label = { display: 'block', fontSize: '12px', fontWeight: 700, color: 'var(--t2)', marginBottom: '7px', textTransform: 'uppercase', letterSpacing: '0.3px' };

export default function AdminPanel() {
  const { getSEO, updateSEO, resetSEO, resetAll } = useSEO();
  const [selected, setSelected] = useState('/');
  const [saved, setSaved] = useState(false);
  const seo = getSEO(selected);
  const [form, setForm] = useState(seo);
  //login state
  const [isAuth, setIsAuth] = useState(false);
  const [password, setPassword] = useState('');
  //reset all confirmation
  const [showConfirm, setShowConfirm] = useState(false);

  //login check on mount
  useEffect(() => {
    const auth = localStorage.getItem('admin_auth');
    if (auth === 'true') {
      setIsAuth(true);
    }
  }, []);

  //login handler
  const handleLogin = () => {
    if (password === 'CodeChain@1992') {
      localStorage.setItem('admin_auth', 'true');
      setIsAuth(true);
    } else {
      alert('Wrong password');
    }
  };


  const selectPage = (path) => {
    setSelected(path);
    setForm(getSEO(path));
    setSaved(false);
  };

  const handleSave = () => {
    updateSEO(selected, form);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  const handleReset = () => {
    resetSEO(selected);
    setForm(getSEO(selected));
    setSaved(false);
  };

  const charCount = (text, max) => {
    const len = (text || '').length;
    const color = len > max ? 'var(--danger)' : len > max * 0.85 ? 'var(--warn)' : 'var(--green)';
    return <span style={{ fontSize: '11px', color }}>{len}/{max}</span>;
  };

  // login page
  if (!isAuth) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ padding: '30px', border: '1px solid #ddd', borderRadius: '10px', }}>
          <h2 style={{ marginBottom: '5px' }}>Admin Login</h2>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleLogin();
              }
            }}
            style={{ padding: '10px', marginBottom: '10px', width: '100%' }}
          />
          <button onClick={handleLogin} style={{ padding: '10px', width: '100%', background: 'rgba(200,92,122,0.1)', border: '1px solid var(--orange)', borderRadius: '5px', padding: '9px 16px', color: 'var(--orange)', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
            Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px 16px' }}>
        {/* Admin Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', marginBottom: '24px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <Link to="/" style={{ fontSize: '12px', color: 'var(--t3)', textDecoration: 'none' }}>← Back to Site</Link>
            </div>
            <h1 style={{ fontSize: '24px', fontWeight: 800, color: 'var(--t1)' }}>⚙️ SEO Admin Panel</h1>
            <p style={{ fontSize: '13px', color: 'var(--t2)', marginTop: '4px' }}>Manage SEO, meta tags, H1 and page intro content for every calculator page.</p>
          </div>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button onClick={() => setShowConfirm(true)} style={{ background: 'rgba(255,92,122,0.1)', border: '1px solid rgba(255,92,122,0.3)', borderRadius: '10px', padding: '9px 16px', color: 'var(--danger)', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
              Reset All Pages
            </button>
            {/* logout button  */}
            <button
              style={{ background: 'rgba(255,92,122,0.1)', border: '1px solid rgba(255,92,122,0.3)', borderRadius: '10px', padding: '9px 16px', color: 'var(--danger)', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}
              onClick={() => {
                localStorage.removeItem('admin_auth');
                setIsAuth(false);
                setPassword('');
              }}
            >
              Logout
            </button>
          </div>
        </div>

        {showConfirm && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 999
          }}>
            <div style={{
              background: 'var(--card)',
              padding: '24px',
              borderRadius: '12px',
              width: '320px',
              textAlign: 'center',
              border: '1px solid var(--border)'
            }}>
              <h3 style={{ marginBottom: '10px' }}>⚠️ Confirm Reset</h3>
              <p style={{ fontSize: '13px', color: 'var(--t2)', marginBottom: '20px' }}>
                Are you sure you want to reset all pages?
              </p>

              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                <button
                  onClick={() => setShowConfirm(false)}
                  style={{
                    padding: '8px 14px',
                    borderRadius: '8px',
                    border: '1px solid var(--border)',
                    background: 'transparent',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>

                <button
                  onClick={() => {
                    resetAll();
                    setShowConfirm(false);
                  }}
                  style={{
                    padding: '8px 14px',
                    borderRadius: '8px',
                    border: 'none',
                    background: 'var(--danger)',
                    color: '#fff',
                    cursor: 'pointer'
                  }}
                >
                  Yes, Reset
                </button>
              </div>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '20px', alignItems: 'start' }}>
          {/* Page List Sidebar */}
          <aside style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '14px', overflow: 'hidden', position: 'sticky', top: '76px' }}>
            <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)', fontSize: '11px', fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '0.8px' }}>All Pages ({ALL_PATHS.length})</div>
            <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {ALL_PATHS.map(path => (
                <button key={path} onClick={() => selectPage(path)} style={{
                  width: '100%', padding: '11px 14px', background: selected === path ? 'rgba(255,107,44,0.1)' : 'transparent',
                  border: 'none', borderBottom: '1px solid var(--border)', cursor: 'pointer',
                  textAlign: 'left', transition: 'background 0.18s',
                  borderLeft: selected === path ? '3px solid var(--orange)' : '3px solid transparent',
                }}>
                  <div style={{ fontSize: '13px', fontWeight: selected === path ? 700 : 500, color: selected === path ? 'var(--orange)' : 'var(--t1)' }}>
                    {ALL_NAMES[path] || path}
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--t3)', marginTop: '2px' }}>{path}</div>
                </button>
              ))}
            </div>
          </aside>

          {/* Edit Form */}
          <div>
            <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '16px', padding: '24px', marginBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
                <div>
                  <h2 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--t1)', marginBottom: '2px' }}>
                    {ALL_NAMES[selected] || selected}
                  </h2>
                  <code style={{ fontSize: '12px', color: 'var(--t3)', background: 'var(--surface)', padding: '2px 8px', borderRadius: '4px' }}>{selected}</code>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={handleReset} style={{ background: 'transparent', border: '1px solid var(--border)', borderRadius: '9px', padding: '8px 14px', color: 'var(--t2)', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif', transition: 'all 0.18s' }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--orange)'; e.currentTarget.style.color = 'var(--orange)'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--t2)'; }}>
                    Reset to Default
                  </button>
                  <button onClick={handleSave} style={{
                    background: saved ? 'var(--green)' : 'var(--orange)', border: 'none',
                    borderRadius: '9px', padding: '8px 20px', color: 'white',
                    fontSize: '13px', fontWeight: 700, cursor: 'pointer',
                    fontFamily: 'Inter, sans-serif', transition: 'all 0.2s',
                    boxShadow: `0 4px 14px ${saved ? 'rgba(45,212,160,0.4)' : 'rgba(255,107,44,0.35)'}`,
                  }}>
                    {saved ? '✓ Saved!' : '💾 Save Changes'}
                  </button>
                </div>
              </div>

              {/* SEO Fields */}
              <div style={{ display: 'grid', gap: '18px' }}>
                {/* Page Title */}
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '7px' }}>
                    <label style={label}>Page Title (SEO) — shown in Google results</label>
                    {charCount(form.title, 60)}
                  </div>
                  <input
                    style={{ ...inp, fontFamily: 'inherit' }}
                    value={form.title || ''}
                    onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
                    placeholder="Page Title | Site Name"
                    onFocus={e => e.target.style.borderColor = 'var(--orange)'}
                    onBlur={e => e.target.style.borderColor = 'var(--border)'}
                  />
                  <div style={{ fontSize: '11px', color: 'var(--t3)', marginTop: '4px' }}>✅ Ideal: 50–60 characters. Shown as the blue link in Google search results.</div>
                </div>

                {/* Meta Description */}
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '7px' }}>
                    <label style={label}>Meta Description — shown below title in Google</label>
                    {charCount(form.description, 160)}
                  </div>
                  <textarea
                    style={textareaStyle}
                    value={form.description || ''}
                    onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
                    placeholder="Describe this page in 150–160 characters..."
                    onFocus={e => e.target.style.borderColor = 'var(--orange)'}
                    onBlur={e => e.target.style.borderColor = 'var(--border)'}
                  />
                  <div style={{ fontSize: '11px', color: 'var(--t3)', marginTop: '4px' }}>✅ Ideal: 150–160 characters. Directly affects click-through rates from Google.</div>
                </div>

                {/* Keywords */}
                <div>
                  <label style={label}>Focus Keywords (comma-separated)</label>
                  <input
                    style={{ ...inp, fontFamily: 'inherit' }}
                    value={form.keywords || ''}
                    onChange={e => setForm(f => ({ ...f, keywords: e.target.value }))}
                    placeholder="EMI calculator, loan EMI India, monthly installment..."
                    onFocus={e => e.target.style.borderColor = 'var(--orange)'}
                    onBlur={e => e.target.style.borderColor = 'var(--border)'}
                  />
                  <div style={{ fontSize: '11px', color: 'var(--t3)', marginTop: '4px' }}>Used in meta keywords tag. Include your main target keywords.</div>
                </div>

                {/* H1 */}
                <div>
                  <label style={label}>H1 Heading — Main heading shown on page</label>
                  <input
                    style={{ ...inp, fontFamily: 'inherit' }}
                    value={form.h1 || ''}
                    onChange={e => setForm(f => ({ ...f, h1: e.target.value }))}
                    placeholder="Main page heading (H1)..."
                    onFocus={e => e.target.style.borderColor = 'var(--orange)'}
                    onBlur={e => e.target.style.borderColor = 'var(--border)'}
                  />
                  <div style={{ fontSize: '11px', color: 'var(--t3)', marginTop: '4px' }}>✅ Should include your primary keyword. Only one H1 per page.</div>
                </div>

                {/* Page Intro */}
                <div>
                  <label style={label}>Page Intro Text — shown below H1 heading</label>
                  <textarea
                    style={{ ...textareaStyle, minHeight: '100px' }}
                    value={form.intro || ''}
                    onChange={e => setForm(f => ({ ...f, intro: e.target.value }))}
                    placeholder="Describe what this calculator does and why users should use it..."
                    onFocus={e => e.target.style.borderColor = 'var(--orange)'}
                    onBlur={e => e.target.style.borderColor = 'var(--border)'}
                  />
                  <div style={{ fontSize: '11px', color: 'var(--t3)', marginTop: '4px' }}>Visible to users and search engines. Include keywords naturally. 100–200 words ideal.</div>
                </div>
              </div>
            </div>

            {/* Preview Card */}
            <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '16px', padding: '20px' }}>
              <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '14px' }}>Google Search Preview</div>
              <div style={{ background: 'var(--bg)', border: '1px solid var(--border2)', borderRadius: '12px', padding: '16px 18px' }}>
                <div style={{ fontSize: '13px', color: 'var(--t3)', marginBottom: '4px' }}>apnaacalculator.com{selected}</div>
                <div style={{ fontSize: '17px', color: 'var(--blue)', fontWeight: 600, marginBottom: '6px', lineHeight: 1.3, cursor: 'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
                  onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}>
                  {form.title || 'Page Title'}
                </div>
                <div style={{ fontSize: '13px', color: 'var(--t2)', lineHeight: 1.6 }}>
                  {form.description || 'Meta description will appear here...'}
                </div>
              </div>

              {/* SEO Score */}
              <div style={{ marginTop: '16px' }}>
                <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '10px' }}>SEO Score</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px' }}>
                  {[
                    { label: 'Title length', ok: (form.title || '').length >= 30 && (form.title || '').length <= 60, msg: `${(form.title || '').length} chars (ideal: 50-60)` },
                    { label: 'Description length', ok: (form.description || '').length >= 120 && (form.description || '').length <= 160, msg: `${(form.description || '').length} chars (ideal: 150-160)` },
                    { label: 'H1 heading set', ok: (form.h1 || '').length > 0, msg: form.h1 ? 'Set ✓' : 'Not set' },
                    { label: 'Keywords defined', ok: (form.keywords || '').split(',').filter(k => k.trim()).length >= 3, msg: `${(form.keywords || '').split(',').filter(k => k.trim()).length} keywords` },
                    { label: 'Intro text', ok: (form.intro || '').length > 80, msg: `${(form.intro || '').length} chars (ideal: 100+)` },
                  ].map(({ label, ok, msg }) => (
                    <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: ok ? 'rgba(45,212,160,0.07)' : 'rgba(255,92,122,0.07)', border: `1px solid ${ok ? 'rgba(45,212,160,0.2)' : 'rgba(255,92,122,0.2)'}`, borderRadius: '8px' }}>
                      <span style={{ fontSize: '14px' }}>{ok ? '✅' : '⚠️'}</span>
                      <div>
                        <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--t1)' }}>{label}</div>
                        <div style={{ fontSize: '11px', color: 'var(--t2)' }}>{msg}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* SEO Tips */}
            <div style={{ background: 'rgba(79,142,247,0.07)', border: '1px solid rgba(79,142,247,0.2)', borderRadius: '14px', padding: '18px', marginTop: '16px' }}>
              <div style={{ fontSize: '14px', fontWeight: 700, color: 'var(--blue)', marginBottom: '10px' }}>💡 SEO Tips for Calculator Pages</div>
              <ul style={{ fontSize: '13px', color: 'var(--t2)', lineHeight: 2, paddingLeft: '16px' }}>
                <li>Include the calculator name + "India" in your title (e.g., "EMI Calculator India 2024")</li>
                <li>Add the year (2024/2025) to titles for freshness signals</li>
                <li>Meta description should answer: what does this calculator do + why use it</li>
                <li>H1 should match or closely relate to your title tag keyword</li>
                <li>Intro text: naturally include 2–3 keywords without stuffing</li>
                <li>Target long-tail keywords like "home loan EMI calculator 2024 India"</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
